'use strict';
import NavEvent from './components/NavEvent';

document.addEventListener('DOMContentLoaded', () => {
  const navEvent = new NavEvent();
});
